import api from './api';

// Client Invitations — New Client Invitation lifecycle (onboarding Module 2).
export const invitationsAPI = {
  // Staff
  list: (params) => api.get('/api/client-invitations', { params }),
  get: (id) => api.get(`/api/client-invitations/${id}`),
  update: (id, data) => api.patch(`/api/client-invitations/${id}`, data),
  create: (data) => api.post('/api/client-invitations', data),
  resend: (id, base_url) => api.post(`/api/client-invitations/${id}/resend`, { base_url }),
  cancel: (id) => api.post(`/api/client-invitations/${id}/cancel`),

  // Public (token-based; no auth)
  getByToken: (token) => api.get(`/api/public/invitations/${token}`),
  register: (token, data) => api.post(`/api/public/invitations/${token}/register`, data),
};

export const CLIENT_TYPE_OPTIONS = [
  { value: 'individual', label: 'Individual' },
  { value: 'sole_trader', label: 'Sole Trader' },
  { value: 'company', label: 'Company' },
  { value: 'trust', label: 'Trust' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'smsf', label: 'SMSF' },
];

export const ENGAGEMENT_TYPE_OPTIONS = [
  { value: 'individual_tax_return', label: 'Individual Tax Return' },
  { value: 'business_tax_return', label: 'Business Tax Return' },
  { value: 'bas_gst', label: 'BAS / GST' },
  { value: 'payroll_paygw', label: 'Payroll / PAYG withholding (IAS)' },
  { value: 'bookkeeping', label: 'Bookkeeping' },
  { value: 'asic_company_secretarial', label: 'ASIC / Company Secretarial' },
  { value: 'advisory', label: 'Advisory' },
  { value: 'other', label: 'Other' },
];

// status -> { label, color } for badges
export const INVITATION_STATUS_META = {
  invitation_sent: { label: 'Invitation Sent', color: 'bg-blue-100 text-blue-800' },
  link_opened: { label: 'Link Opened', color: 'bg-cyan-100 text-cyan-800' },
  registration_started: { label: 'Registration Started', color: 'bg-amber-100 text-amber-800' },
  documents_pending: { label: 'Documents Pending', color: 'bg-orange-100 text-orange-800' },
  submitted: { label: 'Submitted', color: 'bg-indigo-100 text-indigo-800' },
  reviewed: { label: 'Reviewed', color: 'bg-purple-100 text-purple-800' },
  client_created: { label: 'Client Created', color: 'bg-green-100 text-green-800' },
  cancelled: { label: 'Cancelled', color: 'bg-muted text-muted-foreground' },
};
